import * as THREE from "three";

export function makeShieldBubble(): THREE.Mesh {
  const geom = new THREE.SphereGeometry(0.9, 16, 12);
  const mat = new THREE.MeshBasicMaterial({
    color: 0x66e0ff,
    transparent: true,
    opacity: 0.35,
    side: THREE.DoubleSide,
    depthWrite: false,
  });
  const mesh = new THREE.Mesh(geom, mat);
  mesh.position.y = 0.9;
  return mesh;
}

export function disposeShieldBubble(mesh: THREE.Mesh) {
  mesh.geometry.dispose();
  (mesh.material as THREE.Material).dispose();
}
